 <template>
    <div>
      <!--Header-->
      <div class="custom-menu flex-shrink-0" v-show="true">
        <div class="container-fluid d-flex justify-content-between align-items-center px-md-5 py-4">
          <h3 class="m-0 text-white flex-grow-1">
            <span>Task Details</span>
          </h3>
          <div class="d-flex">
            <div class="mx-1 input-group">
              <div class="input-group-append rounded-left">
                <span class="input-group-text">
                  Location
                </span>
              </div>
              <b-form-select v-if="locationResultsForList" v-model="selectedLocationResultId" :options="locationResultsForList.results" text-field="name" value-field="resultId" @change="onSelectLocation">
                <!-- This slot appears above the options from 'options' prop -->
                <template #first>
                  <b-form-select-option :value="null" disabled>-- Choose a location to continue --</b-form-select-option>
                </template>
              </b-form-select>
            </div>
            <router-link title="ManageTasks" :to="{ name: 'RoutineTasks', params: { requestedPropertyId: this.fromPropertyId, requestedWeekOf: this.fromWeekOf }}" class="btn btn-light">Close</router-link>
          </div>
        </div>
      </div>
      <!--Progress Indicator-->
      <div v-if="loading && selectedLocationResultId" class="container form-container p-5 p-md-4 d-flex justify-content-center">
        <span><b-spinner small label="Small Spinner"></b-spinner> Loading Data for Location...</span>
      </div>
      <div v-else class="flex-grow-1 overflow-auto container-fluid px-5 pt-4">
        <div class v-if="routineTaskToManageForDisplay && userPermissions.manageEvents">
          <div class="row">
          <div class="col-lg-4 col-md-5 col-12 py-4">
            <div class="form-container p-md-4">
            <div><label class="control-label">Status:</label> {{routineTaskToManageForDisplay.status}}</div>
            <div><label class="control-label">Location:</label> {{routineTaskToManageForDisplay.property.name}} - {{routineTaskToManageForDisplay.location}}</div>
            <div v-if="routineTaskToManageForDisplay.status !== 'NotStarted'">
              <div><label class="control-label">Date Started:</label> {{ routineTaskToManageForDisplay.dateStartedLocal | formatDate}}</div>
              <div><label class="control-label">Started By:</label> {{ routineTaskToManageForDisplay.startedByPerson.firstName}} {{ routineTaskToManageForDisplay.startedByPerson.lastName}}</div>
            </div>
            <div v-if="routineTaskToManageForDisplay.status === 'Complete'">
              <div><label class="control-label">Date Completed:</label> {{ routineTaskToManageForDisplay.dateCompletedLocal | formatDate}}</div>
              <div><label class="control-label">Completed By:</label> {{ routineTaskToManageForDisplay.completedByPerson.firstName}} {{ routineTaskToManageForDisplay.completedByPerson.lastName}}</div>
            </div>
            </div>
          </div>
          <div class="px-5 col-lg-8 col-md-7 col-12">
            <h5 class="mt-4 mb-2">Task/Inspection Requirements</h5>
            <div class="list-group">
              <div
                  class="list-group-item"
                  v-for="question in routineTaskToManageForDisplay.sopQuestions"
                  v-bind:key="question.id"
              >
                <div class="row">
                  <div class="col-12 col-md-12 col-lg-6">
                      <strong>{{question.text}}</strong>
                  </div>
                  <div class="col">
                    <div>{{question.answer}}</div>
                    <div v-if="question.typeDescriptor === 'Checklist'">
                          <b-form-checkbox disabled v-for="checklistItem in question.checklistItems" v-bind:key="checklistItem.text" v-model="checklistItem.checked">{{checklistItem.text}}</b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

// import router from '../router'
export default {
  name: 'StatusDropdown',
  components: {
  },

  data () {
    return {
      loading: false,
      routineTaskToManageForDisplay: null,
      locationResultsForList: null,
      selectedLocationResultId: null
    }
  },
  computed: {
    instanceId () {
      return this.$route.params.instanceId
    },
    fromPropertyId () {
      return this.$route.params.fromPropertyId
    },
    fromWeekOf () {
      return this.$route.params.fromWeekOf
    },
    userPermissions () {
      return this.$store.state.loggedInUserPermissions
    }
  },
  created () {
    this.doLoadRoutineTaskToManageForDisplay()
  },
  methods: {
    ...mapActions('routineTasks', ['getLocationResultsForList', 'getLocationResult']),
    async doLoadRoutineTaskToManageForDisplay () {
      // console.log('params: ' + JSON.stringify(this.$route.params, null, 2))
      console.log('Loading instance: ' + this.instanceId)
      this.locationResultsForList = await this.getLocationResultsForList({instanceId: this.instanceId})
      this.selectedLocationResultId = this.locationResultsForList.results[0].resultId
      this.onSelectLocation(this.selectedLocationResultId)
      console.log('results: ' + JSON.stringify(this.locationResultsForList, null, 2))
    },
    async onSelectLocation (locationResultId) {
      this.loading = true
      this.routineTaskToManageForDisplay = (await this.getLocationResult({instanceId: this.instanceId, resultId: locationResultId})).result
      this.loading = false
    }
  },
  ...mapActions('routinetasks', [
    'loadRoutineTaskToManageForDisplay'
  ])
}
</script>

<style>
.ui.modals.active .modal {
  height: auto;
}
.input-upload {
  padding: 7px !important;
}
.image-list:empty::after {
  content: "No Event Images";
  color: #888;
  display: block;
  padding: 4em 3em;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  width: 100%;
}
.image-list .card {
  max-height: 90px;
  overflow: hidden;
  object-fit: cover;
  object-position: center center;
  padding: 0;
  position: relative;
  min-width: 33%;
}
.image-list .card img{
  object-fit: cover;
  height: 100%;
}
.image-list .card:nth-child(3n) {
  margin-left: 5px;
  margin-right: 5px;
}
.image-list .card:first-child {
  max-height: 180px;
  width: 100%;
  min-width: 100%;
  margin: 0;
}
.no-documents:empty::after {
  content: "No Documents";
  color: #888;
  display: block;
  padding: 4em 3em;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  width: 100%;
}
.no-claims:empty::after {
  content: "No Claims";
  color: #888;
  display: block;
  padding: 4em 3em;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  width: 100%;
}
.custom-tabs .tab-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.custom-tabs .tab-content,
.custom-menu.menu > div {
  max-width: 1280px;
  margin: auto !important;
  border: none;
}
.container.flush {
  padding: 0 !important;
  margin: 0 !important;
}
.custom-tabs .nav-tabs {
  display: flex;
  justify-content: center;
  background-color: #13385a !important;
  flex-wrap: nowrap;
}
.custom-tabs .nav-tabs .nav-link {
  color: #fff;
}
.custom-tabs .nav-tabs .nav-link:hover {
  border-color: transparent;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
}
.custom-tabs .nav-tabs .nav-link.active,
.custom-tabs .nav-tabs .nav-link.active:hover {
    color: #495057;
    background-color: #f1f1f1;
    border-color: #dee2e6 #dee2e6 #f1f1f1;
}
.custom-menu {
  background-color: #13385a !important;
}
.custom-menu h2,
.custom-tabs .tabular.menu > .item {
  color: #fff;
}
.custom-menu .close {
  font-size: 220%;
  text-shadow: none;
  color: rgba(255, 255, 255, 0.75);
}

</style>



// WEBPACK FOOTER //
// src/views/RoutineTaskInstanceManage.vue